import React from 'react';
import {Alert} from "@material-ui/lab";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <Alert severity="error">
                    Well, this in embarrassing&hellip; something went wrong.
                </Alert>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;